import { useEffect } from 'react'
import { BrowserRouter, Navigate, Route, Routes, useLocation } from 'react-router-dom'
import HomePage from '../HomePage/HomePage'
import AuthorsRightsPage from '../PoliciesPages/AuthorsRights'
import PrivacyPolicy from '../PoliciesPages/PrivacyPolicy'
import TermsOfUse from '../PoliciesPages/TermsOfUse'
import AboutUsPage from '../AboutUsPage'
import NavigationBar from '../NavigationBar/NavigationBar'
import Footer from '../HomePage/Footer'
import AcademyPage from '../HomePage/AcademyPage'
import InsidePage from '../InsidePage/InsidePage'
import InsideSalesPage from '../InsidePage/InsideSalesPage'
import AvancarSalesPage from '../InsidePage/AvancarSalesPage'
import CentralEnergeticaSalesPage from '../InsidePage/CentralEnergeticaSalesPage'
import CfoDemoPage from '../InsidePage/CfoDemoPage'
import EvoluccionareSalesPage from '../InsidePage/EvoluccionareSalesPage'
import ImersaoRecomecarPage from '../InsidePage/ImersaoRecomecarPage'
import NextSalesCreditoPage from '../InsidePage/NextSalesCreditoPage'
import MontclassSalesPage from '../InsidePage/MontclassSalesPage'
import SolutioSalesPage from '../InsidePage/SolutioSalesPage'
import WorkWithUsPage from '../WorkWithUsPage'
import TransformationServicesPage from '../TransformationServicesPage/TransformationServicesPage.jsx'
import BenjaminThankYouPage from '../BenjaminThankYouPage/BenjaminThankYouPage'
import ForwardDeployedEngineeringPage from '../ForwardDeployedEngineeringPage/ForwardDeployedEngineeringPage'
import BenjaminCheckoutPage from '../Checkout/BenjaminCheckoutPage'
import ServicesCatalogPage from '../ServicesCatalogPage/ServicesCatalogPage'
import HowWeWorkPage from '../HowWeWorkPage/HowWeWorkPage'
import PlatformsPage from '../PlatformsPage/PlatformsPage'
import MaestroPage from '../MaestroPage/MaestroPage'
import InsightsPage from '../InsightsPage/InsightsPage'
import TalkPage from '../TalkPage/TalkPage'
import BookingPage from '../BookingPage/BookingPage'
import StrategicPlanningPage from '../StrategicPlanningPage/StrategicPlanningPage'
import SpeakingPage from '../SpeakingPage/SpeakingPage'

// Sends the browser to an external URL -- used for product pages now hosted on benjaminintelligence.com
const ExternalRedirect = ({ to }) => {
  useEffect(() => { window.location.href = to }, [to])
  return null
}

const RouterShell = ({ children }) => {
  const location = useLocation()
  const isCheckoutFlow = location.pathname === '/checkout/benjamin'

  useEffect(() => {
    if (typeof window === 'undefined') return
    const isJSDOM = /jsdom/i.test(window.navigator.userAgent || '')
    if (isJSDOM || typeof window.scrollTo !== 'function') return

    if (location.hash) return

    window.scrollTo({ top: 0, left: 0, behavior: 'auto' })
  }, [location.pathname, location.search, location.hash])

  useEffect(() => {
    if (typeof window === 'undefined') return
    const isJSDOM = /jsdom/i.test(window.navigator.userAgent || '')
    if (isJSDOM || !location.hash) return

    const targetId = location.hash.replace('#', '')
    const target = document.getElementById(targetId)
    if (!target) return

    const scrollToTarget = () => {
      const top = target.getBoundingClientRect().top + window.scrollY - 110
      window.scrollTo({ top: Math.max(top, 0), left: 0, behavior: 'smooth' })
    }

    const rafId = window.requestAnimationFrame(scrollToTarget)
    return () => window.cancelAnimationFrame(rafId)
  }, [location.pathname, location.hash])

  return (
    <>
      {!isCheckoutFlow && <NavigationBar />}
      <Routes>
        {children}
        <Route path="/" element={<HomePage />} />
        <Route path="/about" element={<AboutUsPage />} />
        <Route path="/academy" element={<AcademyPage />} />
        <Route path="/inside" element={<InsidePage />} />
        <Route path="/inside-sales" element={<InsideSalesPage />} />
        <Route path="/avancar-sales" element={<AvancarSalesPage />} />
        <Route
          path="/central-energetica-sales"
          element={<CentralEnergeticaSalesPage />}
        />
        <Route path="/cfo-demo" element={<CfoDemoPage />} />
        <Route path="/evoluccionare-sales" element={<EvoluccionareSalesPage />} />
        <Route path="/imersao-recomecar" element={<ImersaoRecomecarPage />} />
        <Route path="/montclass-sales" element={<MontclassSalesPage />} />
        <Route path="/next-sales-credito" element={<NextSalesCreditoPage />} />
        <Route path="/solutio-sales" element={<SolutioSalesPage />} />
        <Route path="/pricing" element={<ExternalRedirect to="https://benjaminintelligence.com" />} />
        <Route path="/how-it-works" element={<ExternalRedirect to="https://benjaminintelligence.com/how-it-works" />} />
        <Route path="/solutions" element={<ExternalRedirect to="https://benjaminintelligence.com/how-it-works" />} />
        <Route path="/solutions/:solutionSlug" element={<ExternalRedirect to="https://benjaminintelligence.com" />} />
        <Route path="/lead-generation" element={<ExternalRedirect to="https://benjaminintelligence.com" />} />
        <Route path="/customer-support" element={<ExternalRedirect to="https://benjaminintelligence.com" />} />
        <Route path="/sales-qualification" element={<ExternalRedirect to="https://benjaminintelligence.com" />} />
        <Route path="/use-cases" element={<ExternalRedirect to="https://benjaminintelligence.com/how-it-works" />} />
        <Route path="/benjamin" element={<ExternalRedirect to="https://benjaminintelligence.com" />} />
        <Route path="/book-demo" element={<ExternalRedirect to="https://benjaminintelligence.com/book-demo" />} />
        <Route path="/work-with-us" element={<WorkWithUsPage />} />
        <Route path="/benjamin-thank-you" element={<BenjaminThankYouPage />} />
        <Route path="/services" element={<ServicesCatalogPage />} />
        {/* The Benjamin-era services page stays reachable for old links. */}
        <Route path="/transformation" element={<TransformationServicesPage />} />
        <Route path="/how-we-work" element={<HowWeWorkPage />} />
        <Route path="/platforms" element={<PlatformsPage />} />
        <Route path="/maestro" element={<MaestroPage />} />
        <Route path="/platforms/maestro" element={<Navigate to="/maestro" replace />} />
        <Route path="/insights" element={<InsightsPage />} />
        <Route path="/talk" element={<TalkPage />} />
        <Route path="/book" element={<BookingPage />} />
        <Route path="/services/strategic-planning" element={<StrategicPlanningPage />} />
        <Route path="/speaking" element={<SpeakingPage />} />
        <Route path="/forward-deployed-engineering" element={<ForwardDeployedEngineeringPage />} />
        {/* Old route kept alive for links already shared; redirects to the new page. */}
        <Route path="/product-engineering" element={<Navigate to="/forward-deployed-engineering" replace />} />
        {/* Merged into /about; kept alive so existing links and search results resolve. */}
        <Route path="/evidence" element={<Navigate to="/about#evidence" replace />} />
        <Route
          path="/politica-de-protecao-aos-direitos-autorais"
          element={<AuthorsRightsPage />}
        />
        <Route path="/termos-de-uso" element={<TermsOfUse />} />
        <Route path="/politica-de-privacidade" element={<PrivacyPolicy />} />
        <Route path="/checkout/benjamin" element={<BenjaminCheckoutPage />} />
      </Routes>
      {/* z-10 keeps the footer above the page-scoped fixed SiteAmbient layer */}
      {!isCheckoutFlow && (
        <div className="relative z-10">
          <Footer />
        </div>
      )}
    </>
  )
}

const Router = ({ children }) => {
  return (
    <BrowserRouter>
      <RouterShell>{children}</RouterShell>
    </BrowserRouter>
  )
}

export default Router
